import * as S from "./UnitText.style";

interface UnitTextProps {
  subject?: string;
}

export const UnitText = ({ subject }: UnitTextProps) => {
  return (
    <S.UnitText>
      <span>단위</span>
      {subject === "sitAndReach"
        ? "cm"
        : subject === "gribStrength"
        ? "kg"
        : subject === "bmi"
        ? "kg/m²"
        : subject === "skeletalMuscleMass"
        ? "kg"
        : subject === "bodyFatPercentage"
        ? "%"
        : ""}
    </S.UnitText>
  );
};
